import ContentOverlay from "../components/content_overlay";

function BibliographyPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Bibliography</h2>}
      text_content={
        <ol style={{ lineHeight: "2" }}>
          <li>
            Aleem Yoosuf, N., &amp; Unaisudheen, T. P. (2021). Impact of flood
            on biodiversity of Kerala: A case study from Malappuram district of
            Kerala, India.&nbsp;
            <em>International Research Journal of Environmental Sciences</em>
            ,&nbsp;<em>10</em>(4), 8-19.
          </li>

          <li>
            Anupama, C., &amp; Sivadasan, M. (2004). Mangroves of Kerala,
            India.&nbsp;<em>RHEEDEA-KERALA-</em>,&nbsp;<em>14</em>(1/2), 9.
          </li>

          <li>
            Bhalchandra, W., Baviskar, R. K., &amp; Nikam, T. B. (2014).
            Diversity of nectariferous and polleniferous bee flora at Anjaneri
            and Dugarwadi hills of Western Ghats of Nasik district (MS)
            India.&nbsp;<em>Journal of Entomology and Zoology Studies</em>
            ,&nbsp;<em>2</em>(4), 244-249.
          </li>

          <li>
            Chandrashekara, U. M., Muraleedharan, P. K., &amp; Sibichan, V.
            (2006). Anthropogenic pressure on structure and composition of a
            shola forest in Kerala, India.&nbsp;
            <em>Journal of Mountain Science</em>,&nbsp;<em>3</em>, 58-70.
          </li>

          <li>
            Cherullipadi, L. B., &amp; Paul, J. (2016). Diversity of herbaceous
            riparian flora in the lower stretch of Bharathappuzha river,
            Kerala.&nbsp;<em>South Indian J. Biol. Sci</em>,&nbsp;<em>2</em>(1),
            191-197.
          </li>

          <li>
            Chitale, V. S., Behera, M. D., &amp; Roy, P. S. (2014). Future of
            endemic flora of biodiversity hotspots in India.&nbsp;
            <em>PloS one</em>,&nbsp;<em>9</em>(12), e115264.
          </li>

          <li>
            Daniels, R. R., Kumar, N. A., &amp; Jayanthi, M. (1995). Endemic,
            rare and threatened flowering plants of South India.&nbsp;
            <em>Current Science</em>,&nbsp;<em>68</em>(5), 493-495.
          </li>

          <li>
            Faizal, S. K., Sheela, R. R. R., &amp; Nilayangode, P. (2022).
            Status of plant bioresources utilised in herbal industries and the
            need for conservation in kerala.&nbsp;
            <em>International Journal of Conservation Science</em>,&nbsp;
            <em>13</em>(1), 267-278.
          </li>

          <li>
            George, M. V., &amp; Christopher, G. (2020). Structure, diversity
            and utilization of plant species in tribal homegardens of Kerala,
            India.&nbsp;<em>Agroforestry systems</em>,&nbsp;<em>94</em>(1),
            297-307.
          </li>

          <li>
            Irwin, S. J., &amp; Narasimhan, D. (2011). Endemic genera of
            angiosperms in India: a review.&nbsp;<em>Rheedea</em>,&nbsp;
            <em>21</em>(1), 87-105.
          </li>

          <li>
            Joshi, A., Tewari, R., &amp; Agnihotri, D. (2014). Plant diversity
            in the Kamthi Formation of India: a review.&nbsp;
            <em>Journal of Palaeosciences</em>,&nbsp;<em>63</em>(1-2)), 127-136.
          </li>

          <li>
            Lakshminarasimhan, P., Gantait, S., Bandyopadhyay, S., &amp;
            Arisdason, W. (2013).&nbsp;
            <em>Bibliography and Abstracts of papers on Flora of Kerala</em>.
            Botanical Survey of India.
          </li>

          <li>
            Magesh, G., &amp; Menon, A. R. R. (2011). Vegetation status, species
            diversity and endemism of Sulimudi forests in southern Western Ghats
            of Kerala, India.&nbsp;<em>Indian Forest</em>,&nbsp;<em>2</em>,
            304-311.
          </li>

          <li>
            Mohan Kumar, B., George, S. J., &amp; Chinnamani, S. (1994).
            Diversity, structure and standing stock of wood in the homegardens
            of Kerala in peninsular India.&nbsp;<em>Agroforestry systems</em>
            ,&nbsp;<em>25</em>, 243-262.
          </li>

          <li>
            Nair, H. R., &amp; Mathew, L. (2024). Floristics and indigenous
            knowledge of agro-climatically diverse Sacred groves of central
            Kerala.&nbsp;<em>Plant Science Today</em>,&nbsp;<em>11</em>(1),
            147-159.
          </li>

          <li>
            Nayar, N. M. (2011). Agrobiodiversity in a biodiversity hotspot:
            Kerala State, India. Its origin and status.&nbsp;
            <em>Genetic Resources and Crop Evolution</em>,&nbsp;<em>58</em>,
            55-82.
          </li>

          <li>
            Nayar, T. S., Sibi, M., Rasiya Beegam, A., Mohanan, N., &amp;
            Rajkumar, G. (2008). Flowering plants of Kerala: status and
            statistics.&nbsp;<em>Rheedea</em>,&nbsp;<em>18</em>(2), 96.
          </li>

          <li>
            Parthasarathy, N. (1999). Tree diversity and distribution in
            undisturbed and human-impacted sites of tropical wet evergreen
            forest in southern Western Ghats, India.&nbsp;
            <em>Biodiversity &amp; Conservation</em>,&nbsp;<em>8</em>,
            1365-1381.
          </li>

          <li>
            Pradeepkumar, T., Indira, V., &amp; Sankar, M. (2015). Nutritional
            evaluation of wild leafy vegetables consumed by tribals in the
            Wayanad District of Kerala.&nbsp;
            <em>
              Proceedings of the National Academy of Sciences, India section B:
              biological sciences
            </em>
            ,&nbsp;<em>85</em>, 93-99.
          </li>

          <li>
            Pradheep, K., Joseph John, K., Latha, M., &amp; Suma, A. (2021).
            Status of crop plants of agricultural importance in Kerala state,
            India: an update.&nbsp;<em>Genetic Resources and Crop Evolution</em>
            ,&nbsp;<em>68</em>(5), 1849-1873.
          </li>

          <li>
            Pramod, C., &amp; Pradeep, A. K. (2021). Observations on the
            flowering plant diversity of Madayippara, a southern Indian
            lateritic plateau from Kerala, India.&nbsp;
            <em>Journal of Threatened Taxa</em>,&nbsp;<em>13</em>(2),
            17780-17806.
          </li>

          <li>
            Raj, M. K., Sivadasan, M., &amp; Ravi, N. (2003). Grass diversity of
            Kerala&ndash;Endemism and its phytogeographical significance.&nbsp;
            <em>
              ) Janarthanam, M. K and Narasimhan, D. Plant Diversity, Human
              Welfare and Conservation. Goa University, Goa
            </em>
            , 8-30.
          </li>

          <li>
            Ram, J., Kumar, A., &amp; Bhatt, J. (2004). Plant diversity in six
            forest types of Uttaranchal, Central Himalaya, India.&nbsp;
            <em>Current science</em>, 975-978.
          </li>

          <li>
            Sabu, T., &amp; Ambat, B. (2007). Floristic analysis of wetlands of
            Kerala. In&nbsp;
            <em>Proceedings of the Kerala Environment Congress</em>(pp. 91-105).
          </li>

          <li>
            Singh, N. P., Vohra, J. N., Hajra, P. K., &amp; Singh, D. K. (2000).
            Flora of India.&nbsp;
            <em>
              Introductory Volume Part II. Botanical Survey of India, Calcutta
            </em>
            .
          </li>

          <li>
            Sreedharan, T. P. (2004).&nbsp;
            <em>
              Biological Diversity of Kerala: A survey of Kalliasseri panchayat,
              Kannur district
            </em>
            . Kerala Research Programme on Local Level Development, Centre for
            Development Studies.
          </li>

          <li>
            Sundarapandian, S., &amp; Karoor, P. J. (2013). Edge effects on
            plant diversity in tropical forest ecosystems at Periyar Wildlife
            sanctuary in the Western Ghats of India.&nbsp;
            <em>Journal of forestry research</em>,&nbsp;<em>24</em>(3), 403-418.
          </li>

          <li>
            Venkatesan, K., Alam, M., &amp; Meena, R. (2023). Conservation
            Status and Diversity of Medicinal Plants Used in Indian System of
            Medicine-A Survey Report from the Munaru Forest Division, Kerala,
            India.&nbsp;
            <em>
              International Research Journal of Pharmaceutical and Applied
              Sciences
            </em>
            ,&nbsp;<em>13</em>(1), 1-11.
          </li>

          <li>
            Vidyasagaran, K., &amp; Madhusoodanan, V. K. (2014). Distribution
            and plant diversity of mangroves in the west coast of Kerala,
            India.&nbsp;<em>J Biodivers Environ Sci</em>,&nbsp;<em>4</em>(5),
            38-45.
          </li>

          <li>
            Xavier, T. F., Kannan, M., Lija, L., Auxillia, A., &amp; Rose, A. K.
            F. (2014). Ethnobotanical study of Kani tribes in thoduhills of
            Kerala, South India.&nbsp;<em>Journal of Ethnopharmacology</em>
            ,&nbsp;<em>152</em>(1), 78-90.
          </li>
        </ol>
      }
    />
  );
}

export default BibliographyPage;
